import React from "react";
import "../App.css";
import Footer from "../components/Footer";

function SignUp() {
    return (
        <>
            <h1 className="sign-up">SIGN UP</h1>
            <Footer />
        </>
    );
}

export default SignUp;
